import { omsStateTone, type OmsStateTone } from "@nova-ai/shared"

import { humanizeEnumLabel } from "./enum-label"

/** StateChip colour variants (mirrors the `kind` prop of `StateChip`). */
type StateChipKind = "good" | "warn" | "bad" | "info"

// Map an OMS state's semantic tone (defined in @nova-ai/shared) to a StateChip
// colour. Contradictions are conveyed by the Problems banner, not by colouring
// an in-flight state as bad — so PENDING/PICKING/PACKED read as neutral info.
const OMS_TONE_CHIP: Record<OmsStateTone, StateChipKind> = {
  success: "good",
  progress: "info",
  attention: "warn",
  failure: "bad",
}

export function omsChipKind(state: string | null | undefined): StateChipKind {
  const tone = omsStateTone(state)
  return tone ? OMS_TONE_CHIP[tone] : "info"
}

/** Display label for an OMS state. Raw states arrive as SNAKE_CASE enums
 *  (`READY_FOR_PICKING`); render them as sentence case, keeping short all-caps
 *  tokens (system acronyms like `AS`) intact. */
export function omsStateLabel(state: string): string {
  if (state === "not_found") {
    return "Not found"
  }
  return humanizeEnumLabel(state)
}
